import { Button } from 'antd';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from '../../../../../AppContext';
import {
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
  ROUTES,
} from '../../../../../common/constants';
import { hasPermission } from '../../../../../common/utils';
import GoBackButton from '../../../../../components/GoBackButton';
import Portal from '../../../../../components/Portal';
import EndUsersTabs from '../components/EndUsersTabs';
import SubscriptionInfo from '../components/SubscriptionInfo';

const ViewSubscriptionDetails = ({
  match: { params: { id, userNumber } = {} } = {},
  isDrawerView = false,
  endUserId,
  endUserNumber,
}) => {
  const {
    state: { permissions },
  } = useContext(AppContext);
  const history = useHistory();

  const currentId = isDrawerView ? endUserId : id;
  const currentUserNumber = isDrawerView ? endUserNumber : userNumber;

  const EditSubscriptionButtons = () =>
    hasPermission(
      PERMISSIONS_KEY?.SYSTEM_USERS_END_USERS,
      PERMISSION_TYPE?.UPDATE,
      permissions,
    ) && (
      <div className="header-btn-wrapper">
        <Button
          className="common-button mr-16"
          size="middle"
          onClick={() =>
            history?.push(
              `${ROUTES?.SYSTEM_USERS}${ROUTES?.END_USERS}${ROUTES?.SUBSCRIPTION_PLAN_DETAILS}/edit/${currentId}/${currentUserNumber}`,
            )
          }
        >
          Edit Subscription
        </Button>
      </div>
    );

  const contentComponent = (
    <div className="full-height-without-details">
      <SubscriptionInfo userId={currentId} isView />
    </div>
  );

  if (isDrawerView) {
    return contentComponent;
  }

  return (
    <>
      <Portal portalId="header-title-content">
        <GoBackButton
          customLink={`${ROUTES?.SYSTEM_USERS}${ROUTES?.END_USERS}`}
        />
        <div className="portal-header">View End User</div>
      </Portal>
      <Portal portalId="header-right-content">
        <EditSubscriptionButtons />
      </Portal>
      <Portal portalId="header-right-content-phones">
        <EditSubscriptionButtons />
      </Portal>
      <EndUsersTabs
        endUserId={currentId}
        endUserNumber={currentUserNumber}
        isView
      >
        {contentComponent}
      </EndUsersTabs>
    </>
  );
};

export default ViewSubscriptionDetails;
